var render = function render(){var _vm=this,_c=_vm._self._c;return _c('el-cascader',{style:({ width: _vm.width }),attrs:{"clearable":"","size":_vm.size,"options":_vm.deptTree,"show-all-levels":false,"props":_vm.cascProps,"filterable":"","placeholder":"请选择","disabled":_vm.disabled},model:{value:(_vm.department),callback:function ($$v) {_vm.department=$$v},expression:"department"}})
}
var staticRenderFns = []

export { render, staticRenderFns }